const campaignParams =
  'utm_source utm_medium utm_campaign utm_term utm_content'.split(' ')

const clickIds =
  'gclid gbraid wbraid msclkid fbclid ttclid li_fat_id twclid'.split(' ')

export function stripPageUrl(
  href: string,
  options: { hashRouting?: boolean; urlParams?: readonly string[] } = {},
): string {
  const url = new URL(href)
  const kept = new URLSearchParams()
  for (const name of [...campaignParams, ...(options.urlParams ?? [])]) {
    const value = url.searchParams.get(name)
    if (value !== null) {
      kept.set(name, value)
    }
  }
  for (const name of clickIds) {
    if (url.searchParams.has(name)) {
      kept.set(name, '1')
    }
  }
  const query = kept.toString()
  const hash = options.hashRouting ? (url.hash.split('?')[0] ?? '') : ''
  return url.origin + url.pathname + (query ? `?${query}` : '') + hash
}

export function stripLinkUrl(href: string): string {
  const url = new URL(href)
  return url.origin + url.pathname
}
